import React from "react";

export default ({ submit, inputs, menu }) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        marginLeft: "250px",
        paddingBottom: "400px",
      }}
    >
      <div
        className="container"
        style={{
          paddingLeft: "35px",
          paddingRight: "35px",
          paddingTop: "20px",
        }}
      >
        <h1 className="font-weight-bold">Edit Menu</h1>
        <div className="col">
          <form
            onSubmit={(e) => submit(e)}
            style={{
              padding: "40px",
              marginRight: "20px",
            }}
          >
            <div
              className="form-group"
              style={{
                paddingBottom: "20px",
              }}
            >
              <h3 className="font-weight-bold">Names</h3>
              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Name
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="nameOfMenu"
                type="text"
                className="form-control"
                placeholder="Menu name..."
                required
                value={menu.nameOfMenu}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇪🇸 - Spanish Name
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="nameOfMenuSpanish"
                type="text"
                className="form-control"
                placeholder="Menu name... "
                value={menu.nameOfMenuSpanish}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇺🇸 - English Name
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="nameOfMenuEnglish"
                type="text"
                className="form-control"
                placeholder="Menu name... "
                value={menu.nameOfMenuEnglish}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇧🇷 - Portuguese Name
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="nameOfMenuPortuguese"
                type="text"
                className="form-control"
                placeholder="Menu name... "
                value={menu.nameOfMenuPortuguese}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇫🇷 - French Name
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="nameOfMenuFrench"
                type="text"
                className="form-control"
                placeholder="Menu name... "
                value={menu.nameOfMenuFrench}
              />
              <h3
                style={{
                  marginTop: "30px",
                }}
                className="font-weight-bold"
              >
                Details
              </h3>
              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Image of Menu
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="imageMenu"
                type="text"
                className="form-control"
                placeholder="URL Image"
                required
                value={menu.imageMenu}
              />
              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Hours
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="hours"
                type="text"
                className="form-control"
                placeholder="Hours..."
                required
                value={menu.hours}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Order Number
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="orderMenu"
                type="text"
                className="form-control"
                placeholder="1, 2, 3..."
                value={menu.orderMenu}
                required
              />
              <h3
                style={{
                  marginTop: "30px",
                }}
                className="font-weight-bold"
              >
                Aclarations
              </h3>
              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇪🇸 - Spanish Aclarations
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="aclarationSpanish"
                type="text"
                className="form-control"
                placeholder="Tax included..."
                value={menu.aclarationSpanish}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇺🇸 - English Aclarations
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="aclarationEnglish"
                type="text"
                className="form-control"
                placeholder="Tax included..."
                value={menu.aclarationEnglish}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇧🇷 - Portuguese Aclarations
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="aclarationPortuguese"
                type="text"
                className="form-control"
                placeholder="Tax included..."
                value={menu.aclarationPortuguese}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇫🇷 - French Aclarations
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="aclarationFrench"
                type="text"
                className="form-control"
                placeholder="Tax included..."
                value={menu.aclarationFrench}
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary"
              style={{
                backgroundColor: "#FF2068",
                borderColor: "#FF2068",
              }}
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
